import React from "react";
import { motion } from "framer-motion";
import { FaInstagram, FaFacebookF, FaWhatsapp, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import "../styles/contact.css";

function Contact() {
  return (
  <section className="contact">
      {/* 🌸 TÍTULO PRINCIPAL */}
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="text-4xl md:text-5xl font-playfair text-[#3F342F] mb-6 text-center"
      >
        Contactanos 💌
      </motion.h2>

      {/* 🌷 DESCRIPCIÓN */}
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.8 }}
        className="text-center text-[#3F342F]/80 mb-12 max-w-2xl text-lg leading-relaxed"
      >
        En <strong className="text-[#b08b76]">Shanna Biopeluquería</strong> creemos en una belleza más natural, 
        consciente y armónica. Podés comunicarte con nosotras para consultas, turnos o colaboraciones, 
        o seguir nuestras redes para inspirarte con nuestros trabajos y consejos 💫
      </motion.p>

      {/* 🌸 REDES SOCIALES */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="flex flex-wrap justify-center gap-8 mb-16"
      >
        {[
          {
            icon: <FaInstagram />,
            href: "https://www.instagram.com/multiespacio.shanna",
            label: "Instagram",
            color: "#E4405F",
          },
          {
            icon: <FaFacebookF />,
            href: "https://www.facebook.com/sandranoemi.olivares.9",
            label: "Facebook",
            color: "#1877F2",
          },
          {
            icon: <FaWhatsapp />,
            href: "https://wa.me/5492665041280",
            label: "WhatsApp",
            color: "#25D366",
          },
        ].map((red, i) => (
          <motion.a
            key={i}
            href={red.href}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.15, rotate: 5 }}
            whileTap={{ scale: 0.95 }}
            className="flex flex-col items-center text-[#3F342F] hover:text-[#b08b76] transition-all"
          >
            <div
              className="bg-white p-5 rounded-full shadow-md"
              style={{ boxShadow: `0 6px 15px ${red.color}30` }}
            >
              <span className="text-4xl">{red.icon}</span>
            </div>
            <span className="mt-2 text-sm font-medium">{red.label}</span>
          </motion.a>
        ))}
      </motion.div>

      {/* 🌸 INFORMACIÓN DE CONTACTO */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="bg-white/70 backdrop-blur-md p-8 rounded-2xl shadow-md max-w-lg w-full text-center border border-[#f1dede]"
      >
        <h3 className="text-xl font-semibold text-[#3F342F] mb-4">Información de contacto</h3>
        <div className="flex flex-col gap-3 text-[#3F342F]/90">
          <p className="flex items-center justify-center gap-2">
            <FaMapMarkerAlt className="text-[#b08b76]" /> San Luis, Argentina
          </p>
          <p className="flex items-center justify-center gap-2">
            <FaEnvelope className="text-[#b08b76]" /> contacto@shanna.com
          </p>
          <p className="flex items-center justify-center gap-2">
            <FaWhatsapp className="text-[#b08b76]" /> +54 9 2665 04 1280
          </p>
        </div>
      </motion.div>

      {/* 🌸 FOOTER */}
      <footer className="mt-16 text-center text-[#3F342F]/70 text-sm">
        © 2025 <strong className="text-[#b08b76]">Shanna Biopeluquería</strong> — Todos los derechos reservados 🌿
      </footer>
    </section>
  );
}

export default Contact;
